import { alpha } from "@mui/material";
import { pink } from "@mui/material/colors";
import axios from "axios";
import { allOption, selectOptKeyName } from "data/globalData";
import { arrType, datatypes, inputTypes } from "data/globalData";
import { convertValueInCr, convertValueInThousands, roundDecimalValueUptoTwo } from "utils/roundDecimalValue";

export const l1VerticalCardTypes = {
	sale_aop: { name: "SALE / AOP", key: "sale_aop" },
	qty_aop: { name: "UNITS", key: "qty_aop" },
	discount: { name: "DISCOUNT", key: "discount" },
	gp: { name: "GP", key: "gp" },
	gp_contri: { name: "GP CONTRI %", key: "gp_contri" },
	ros: { name: "ROS", key: "ros" },
	str: { name: "STR (Draft)", key: "str" },
};
export const l1verticalCardWidth = "17rem";

export const storeFilterColumns = [
	{
		name: "Channel",
		key: "channel",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Sub Channel",
		key: "sub_channel",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Store",
		key: "store",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},

	{
		name: "LFL/NEW BD",
		key: "lfl_nbd",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Store Type",
		key: "store_type",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
];
export const locationFilterColumns = [
	{
		name: "City",
		key: "city",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Tier",
		key: "tier",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "State",
		key: "state",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	{
		name: "Region",
		key: "region",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
];
export const styleFilterCol = {
	name: "Style",
	key: "style",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	[selectOptKeyName]: {
		type: arrType,
		list: [
			// { name: allOption, key: allOption },
			{ name: "MAINLINE", key: "MAINLINE" },
			{ name: "GUILD", key: "GUILD" },
		],
		getOptionLabel: (opt) => ({ name: opt.style, key: opt.style }),
	},
};
export const colorFilterCol = {
	name: "Color",
	key: "color",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	[selectOptKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
	},
};
export const locationColumns = [
	{
		name: "State",
		key: "state",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
			getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
		},
	},
	{
		name: "City",
		key: "city",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
			getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
		},
	},
	{
		name: "Tier",
		key: "tier",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
			getOptionLabel: (opt) => ({ name: opt.color, key: opt.color }),
		},
	},
];

export const imFilterColumnsObj = {
	brand: {
		name: "Brand",
		key: "brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [{ brand: "RARE RABBIT" }, { brand: "RAREISM", key: "RAREISM" }, { brand: "RAREONES", key: "RAREONES" }],
		},
	},
	sub_brand: {
		name: "Sub Brand",
		key: "sub_brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	season: {
		name: "Season",
		key: "season",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [
				{ season: "AW-24", key: "AW-24" },
				{ season: "AW-25", key: "AW-25" },
				{ season: "SS-25", key: "SS-25" },
				{ season: "SS-24", key: "SS-24" },
			],
		},
	},
	division: {
		name: "Division",
		key: "division",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	sub_category: {
		name: "Sub Category",
		key: "sub_category",
		dependency: { brand: true, category: true },
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [],
		},
	},
	store_brand: {
		name: "Store Brand",
		key: "store_brand",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},

	sleeve: {
		name: "Sleeve",
		key: "sleeve",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},

	section: {
		name: "Section",
		key: "section",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	fashionability: {
		name: "Fashionability",
		key: "fashionability",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
	occasion: {
		name: "Occasion",
		key: "occasion",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		dependency: { brand: true },

		[selectOptKeyName]: {
			type: arrType,
			list: [
				// { name: allOption, key: allOption },
				{ name: "MAINLINE", key: "MAINLINE" },
				{ name: "GUILD", key: "GUILD" },
			],
		},
	},
};
//  const line1Color = " #70225465"; //#f1a6d6
// const line2Color = "#F3B4DC60";    //#702254
const line1Color = alpha(pink[900], 0.4); // 80% opacity
const line2Color = alpha(pink[100], 0.4); // 40% opacity

export const xAxisMonthDataCol = "month";

export const dummySummaryRes = {
	status: "success",
	result: {
		sale_aop: {
			ly_ach_value: 6874912005.63,
			ty_ach_value: 8638264090.999989,
			ty_aop_value: 8914800715.0,
			ly_aop_value: 6101081031.0,
			ty_total_sale_value: 8638264090.999989,
			bar_graph: {
				all: {
					"RARE RABBIT": 7128923832.809988,
					RAREISM: 1029117372.5699986,
					RAREZ: 322330537.070001,
					"RARE ONES": 157892348.55,
				},
				guild: {
					"RARE RABBIT": 544565000.1899997,
					RAREISM: 26662477.209999997,
					"RARE ONES": 344165.0799999999,
				},
				non_guild: {
					"RARE RABBIT": 6584358832.6199875,
					RAREISM: 1002454895.3599986,
					RAREZ: 322330537.070001,
					"RARE ONES": 157548183.47,
				},
				slg: {
					"RARE RABBIT": 69151142.88000004,
					RAREISM: 1888690.9,
				},
			},
			sun_burst_graph: {
				offline: {
					value: 5253072269.989983,
					channels: {
						EBO: 3260502830.389985,
						LFS: 1062823128.5999985,
						MBO: 929746311.0,
					},
				},
				online: {
					value: 2433847258.7599993,
					channels: {
						Marketplace: 1445189157.0499997,
						D2C: 988658101.7099998,
					},
				},
			},
		},
		qty_aop: {
			ly_ach_value: 6874912005.63,
			ty_ach_value: 8638264090.999989,
			ly_qty: 3608044.0,
			ty_qty: 4647899.0,
			ty_total_sale_value: 4647899.0,
			bar_graph: {
				all: {
					"RARE RABBIT": 3924398.0,
					RAREISM: 490823.0,
					"RARE ONES": 138423.0,
					RAREZ: 94255.0,
				},
				guild: {
					"RARE RABBIT": 181353.0,
					RAREISM: 5918.0,
				},
				non_guild: {
					"RARE RABBIT": 3743386.0,
					RAREISM: 484905.0,
					"RARE ONES": 138082.0,
					RAREZ: 94255.0,
				},
				slg: {
					"RARE RABBIT": 75536.0,
					RAREISM: 1636.0,
				},
			},
			sun_burst_graph: {
				offline: {
					value: 2101746.0,
					channels: {
						EBO: 1251933.0,
						LFS: 438221.0,
						MBO: 411592.0,
					},
				},
				online: {
					value: 1323238.0,
					channels: {
						Marketplace: 801519.0,
						D2C: 521719.0,
					},
				},
			},
		},
		discount: {
			ly_ach_value: 5455255087.170002,
			ty_ach_value: 7634719616.690002,
			ty_total_sale_value: 4647899.0,
			bar_graph: {
				all: {
					"RARE RABBIT": 6512861376.440002,
					RAREISM: 691005767.2899998,
					RAREZ: 318574320.49999964,
					"RARE ONES": 112278152.45999998,
				},
				guild: {
					"RARE RABBIT": 270040254.92,
					RAREISM: 11261934.620000001,
				},
				non_guild: {
					"RARE RABBIT": 6243252605.770003,
					RAREISM: 679743832.6699998,
					RAREZ: 318574320.49999964,
					"RARE ONES": 111846668.20999998,
				},
				slg: {
					"RARE RABBIT": 33293972.41000004,
					RAREISM: 930206.0099999998,
				},
			},
			sun_burst_graph: {
				offline: {
					value: 1756613245.4199922,
					channels: {
						EBO: 1056803248.4199919,
						MBO: 380599052.0,
						LFS: 319210945.0,
					},
				},
				online: {
					value: 3429968216.289999,
					channels: {
						Marketplace: 2285194215.6299996,
						D2C: 1144774000.6599991,
					},
				},
			},
		},
		gp: {
			ly_ach_value: 4348348074.4789505,
			ty_ach_value: 5415799659.765566,
			ty_total_sale_value: 5415799659.765566,
			bar_graph: {
				all: {
					"RARE RABBIT": 4513195924.205164,
					RAREISM: 647480508.2901005,
					RAREZ: 166685128.08080113,
					"RARE ONES": 88438099.18950008,
				},
				guild: {
					"RARE RABBIT": 362513532.7168999,
					RAREISM: 17367550.426199995,
				},
				non_guild: {
					"RARE RABBIT": 4150814115.308264,
					RAREISM: 630112957.8639004,
					RAREZ: 166685128.08080113,
					"RARE ONES": 88306375.36950009,
				},
				slg: {
					"RARE RABBIT": 44938707.226999976,
					RAREISM: 1329715.6800000002,
				},
			},
			sun_burst_graph: {
				offline: {
					value: 3531957286.8675523,
					channels: {
						EBO: 2197556539.0319824,
						LFS: 716393506.0355893,
						MBO: 618007241.7999808,
					},
				},
				online: {
					value: 1543347675.1010025,
					channels: {
						Marketplace: 918243025.0220025,
						D2C: 625104650.079,
					},
				},
			},
		},
	},
};
export const lineGraphTypes = {
	realized_Value: {
		name: "RV VS MONTH",
		key: "realized_Value",
		title: "",
		y: {
			label: "SALES (CR)",
			dataCol: "total_realised_value",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_total_realised_value",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 10000000);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_total_realised_value",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 10000000);
			},
		},
	},
	qty: {
		name: "QTY VS MONTH ",
		key: "qty",
		title: "",
		y: {
			label: "QTY (PCS) K",
			dataCol: "total_bill_quantity",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_total_bill_quantity",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 1000);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_total_bill_quantity",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val / 1000);
			},
		},
	},
	asp: {
		name: "ASP VS MONTH",
		key: "asp",
		title: "",
		y: {
			label: "ASP",
			dataCol: "asp",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_asp",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_asp",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	discount_percent: {
		name: "DISC(%) VS MONTH",
		key: "discount_percent",
		title: "",
		y: {
			label: "DISC %",
			dataCol: "discount_percent",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_discount_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_discount_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	gp_percent: {
		name: "GP(%) VS MONTH",
		key: "gp_percent",
		title: "",
		y: {
			label: "GP %",
			dataCol: "gp_percent",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_gp_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_gp_percent",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	gp_value: {
		name: "GP VALUE VS MONTH",
		key: "gp_value",
		title: "",
		y: {
			label: "GP VALUE (CR)",
			dataCol: "gp_value",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_gp_value",
			getColVal: (val) => {
				return convertValueInCr(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_gp_value",
			getColVal: (val) => {
				return convertValueInCr(val);
			},
		},
	},
	avg_mrp_val: {
		name: "AVG MRP VALUE VS MONTH",
		key: "avg_mrp_val",
		title: "",
		y: {
			label: "AVG MRP VALUE",
			dataCol: "avg_mrp_val",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_avg_mrp_val",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_avg_mrp_val",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	upt: {
		name: "UPT VS MONTH",
		key: "upt",
		title: "",
		y: {
			label: "UPT",
			dataCol: "upt",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_upt",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_upt",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
	aov: {
		name: "AOV VS MONTH",
		key: "aov",
		title: "",
		y: {
			label: "AOV",
			dataCol: "aov",
		},
		x: {
			dataCol: xAxisMonthDataCol,
		},
		l1: {
			color: line1Color,
			dataCol: "ly_aov",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
		l2: {
			color: line2Color,
			dataCol: "ty_aov",
			getColVal: (val) => {
				return roundDecimalValueUptoTwo(val);
			},
		},
	},
};

export const getSaleImFields = async () => {
	const res = await axios.get(`/api/reports/get-sale-im-fields`);
	return res.data?.result;
};
